import { STUDENT_PERFORMANCE_ACTION_TYPE } from "../actions-type";

const initialState = {
  results: [],
  totalAverage: 0,
  commonResult: {
    _id: null,
    portfolioResult: null,
    juryEvaluation: null,
    attendancePercentage: 0,
    commonAveragePoint: 0,
    totalAverage: 0,
  },

  loading: false,
  error: null,
};

export const studentPerformanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case STUDENT_PERFORMANCE_ACTION_TYPE.GET_STUDENT_PERFORMANCE_RESULTS:
      return {
        ...state,
        loading: false,
        results: action.payload.data,
        totalAverage: action.payload.totalAverage,
      };
    case STUDENT_PERFORMANCE_ACTION_TYPE.GET_STUDENT_PERFORMANCE_COMMON_RESULTS:
      return {
        ...state,
        loading: false,
        totalAverage: action.payload.totalAverage,
        commonResult: {
          _id: action.payload._id,
          portfolioResult: action.payload.portfolioResult,
          juryEvaluation: action.payload.juryEvaluation,
          attendancePercentage: action.payload.attendancePercentage,
          commonAveragePoint: action.payload.commonAveragePoint,
          totalAverage: action.payload.totalAverage,
        },
      };
    case STUDENT_PERFORMANCE_ACTION_TYPE.STUDENT_PERFORMANCE_LAODING:
      return {
        ...state,
        loading: action.payload,
      };
    case STUDENT_PERFORMANCE_ACTION_TYPE.CREATE_STUDENT_PERFORMANCE_RESULT:
      return {
        ...state,
        loading: false,
        results: [action.payload.data, ...state.results],
        totalAverage: action.payload.totalAverage,
      };
    case STUDENT_PERFORMANCE_ACTION_TYPE.UPDATE_STUDENT_PERFORMANCE_RESULT:
      return {
        ...state,
        results: state.results?.map((result) =>
          result._id === action?.payload?.data?._id ? action.payload.data : result,
        ),
        totalAverage: action.payload.totalAverage,
      };
    case STUDENT_PERFORMANCE_ACTION_TYPE.UPDATE_STUDENT_PERFORMANCE_COMMON_RESULT:
      return {
        ...state,
        loading: false,
        totalAverage: action.payload.totalAverage,
        commonResult: {
          ...state.commonResult,
          portfolioResult: action.payload.portfolioResult,
          juryEvaluation: action.payload.juryEvaluation,
          attendancePercentage: action.payload.attendancePercentage,
          commonAveragePoint: action.payload.commonAveragePoint,
        },
      };
    case STUDENT_PERFORMANCE_ACTION_TYPE.DELETE_STUDENT_PERFORMANCE_RESULT:
      return {
        ...state,
        loading: false,
        results: state.results.filter((item) => item._id !== action.payload),
        totalAverage: action.payload.totalAverage,
      };
    default:
      return state;
  }
};
